import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const SidebarColumn = ({ }) => {
  const [activeObject, setActiveObject] = useState({
    home: window.location.pathname.includes("FacilityChart") || window.location.pathname.includes("PatientChart") ? "mm-active" : "",
    reportdata: "",
    linelist: "",
    FacilityChart: window.location.pathname.includes("FacilityChart") ? "mm-active" : "",
    PatientChart: window.location.pathname.includes("PatientChart") ? "mm-active" : "" ,
  });
  const setActiveTab = () => {
    let activeStateHolder = {
      home: "",
      reportdata: "",
      linelist: "",
      alerts: "",
      FacilityChart: "",
      PatientChart: "",
    }
    let currentPath = window.location.pathname.split('/').pop()
    activeStateHolder[currentPath] = "mm-active"
    setActiveObject(activeStateHolder)
  }
  return (<>
    <div className="scrollbar-sidebar">
      <div className="app-sidebar__inner">
        <ul className="vertical-nav-menu">
          <li className="app-sidebar__heading" onClick={() => setActiveTab()}>
            <Link
              to="home"
              className={`nav-link ${activeObject.home}`}
            >
              Dashboard
            </Link>
          </li>
          <ul className="submenu">
          <li className="app-sidebar__heading"  onClick={() => setActiveTab()}>
            <Link
              to="PatientChart"
              className={`nav-link ${activeObject.PatientChart}` }
            >Patient Chart
            </Link>
          </li>
          <li className="app-sidebar__heading"  onClick={() => setActiveTab()}>
            <Link
              to="FacilityChart"
              className={`nav-link ${activeObject.FacilityChart}` }
            >Facility Chart
            </Link>
          </li>
          </ul>
          
          <li className="app-sidebar__heading"  onClick={() => setActiveTab()}>
            <Link
              to="linelist"
              className={`nav-link ${activeObject.linelist}`}
            >Linelist
            </Link>
          </li>
          {/* <li className="app-sidebar__heading"  >
            <Link disabled> Alerts</Link>
            <Link
              to="linelist"
              className={`nav-link ${activeObject.alerts}`}
            >Alerts
            </Link>
          </li> */}
        </ul>
      </div>
    </div>
  </>)
}
export default SidebarColumn